
// Import vendor modules.
import { Controller } from "@hotwired/stimulus";
import u from "./umbrella-custom.js";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

export class PrismController extends Controller {

	/**
	* I get called whenever this instance is bound to a host element.
	*/
	connect() {

		if ( this.hasCodeBlocks() && ! this.hasPrism() ) {

			this.loadPrism();

		}

	}

	// ---
	// PRIVATE METHODS.
	// ---

	/**
	* I determine if there are any fenced code blocks in the current comments.
	*/
	hasCodeBlocks() {

		return( !! u( ".m-comments pre code[ class *= 'language-' ]" ).length );

	}


	/**
	* I determine if the Prism assets have already been loaded.
	*/
	hasPrism() {

		return( !! u( "#prism-css" ).length );

	}


	/**
	* I load the Prism assets and apply them to the document.
	*/
	loadPrism() {

		u( "<link>" )
			.attr( "id", "prism-css" )
			.attr( "rel", "stylesheet" )
			.attr( "type", "text/css" )
			.attr( "href", "/linked/vendor/prism-1.14.0/prism.css" )
			.appendTo( document.head )
		;

		u( document.createElement( "script" ) )
			.attr( "id", "prism-js" )
			.attr( "type", "text/javascript" )
			.attr( "src", "/linked/vendor/prism-1.14.0/prism.js" )
			.appendTo( document.head )
		;

	}

}
